import jsCookie from 'js-cookie';

const processLoginToken = (response) => {
  const token = response.access;
  jsCookie.set('token', token);
  return token;
};

export default processLoginToken;
